import React, { useEffect, useRef, useState } from 'react';
import { DEFAULT_TIME_RANGE } from 'shared/consts/schedule';
import styles from './custom-time-picker.module.scss';

interface CustomTimePickerProps {
  index: number | string;
  value: string;
  onChange: (index: number | string, time: string) => void;
  timeOptions: string[];
}

export const CustomTimePicker: React.FC<CustomTimePickerProps> = ({
  index,
  value,
  onChange,
  timeOptions,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedTime, setSelectedTime] = useState(value);
  const containerRef = useRef<HTMLDivElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const itemsRef = useRef<{ [index: string]: HTMLButtonElement | null }>({});
  useEffect(() => {
    if (isOpen) {
      const activeElement =
        itemsRef.current[
          selectedTime !== null ? selectedTime : DEFAULT_TIME_RANGE[0]
        ];
      const dropdown = dropdownRef.current;

      if (activeElement && dropdown) {
        const elementTop = activeElement.offsetTop;
        const elementHeight = activeElement.offsetHeight;
        const dropdownHeight = dropdown.offsetHeight;

        dropdown.scrollTop =
          elementTop - dropdownHeight / 2 + elementHeight / 2;
      }
    }
  }, [isOpen, selectedTime]);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleTimeSelect = (time: string) => {
    setSelectedTime(time);
    onChange(index, time);
    setIsOpen(false);
  };

  return (
    <div ref={containerRef} className={styles.timePicker}>
      <input
        type="text"
        value={selectedTime}
        onClick={() => setIsOpen(!isOpen)}
        className={styles.timePicker__input}
        placeholder="Выберите время"
        readOnly
      />
      <div
        ref={dropdownRef}
        className={`${styles.timePicker__dropdown} ${
          isOpen ? styles.timePicker__dropdown__open : ''
        }`}
      >
        {timeOptions.map((time) => (
          <button
            key={time}
            ref={(el) => (itemsRef.current[time] = el)}
            onClick={() => handleTimeSelect(time)}
            className={`${styles.timePicker__dropdownItem} ${
              time === selectedTime ? styles.timePicker__dropdownItemActive : ''
            }`}
          >
            {time}
          </button>
        ))}
      </div>
    </div>
  );
};
